module.exports = __webpack_public_path__ + "media/images/flags/es-5cb27aff6057bc852496fd9fc8f2390d.svg";